import { ShieldCheck } from "lucide-react";

export const CqcBadge = ({ variant = "light", className = "" }) => {
  const isDark = variant === "dark";
  return (
    <div
      className={`inline-flex items-center gap-3 rounded-full px-5 py-2.5 ${
        isDark
          ? "bg-brand-deep text-white"
          : "bg-white border border-brand-line text-brand-ink"
      } ${className}`}
      data-testid="cqc-badge"
    >
      <div
        className={`flex items-center justify-center w-8 h-8 rounded-full ${
          isDark ? "bg-white/15" : "bg-brand-deep"
        }`}
      >
        <ShieldCheck
          className={`w-4 h-4 ${isDark ? "text-white" : "text-white"}`}
          strokeWidth={2.2}
        />
      </div>
      <div className="leading-tight">
        <p
          className={`text-[10px] uppercase tracking-[0.18em] font-semibold ${
            isDark ? "text-white/70" : "text-brand-mute"
          }`}
        >
          Care Quality Commission
        </p>
        <p className="text-sm font-semibold">Regulated Care Provider</p>
      </div>
    </div>
  );
};
